module.exports = __webpack_public_path__ + "img/icon-vanguards-le_woodsy.ea724f4.png";